import { Descriptions } from 'antd';
import { keyDetailsItems } from '../utils/keyDetailsItems';
import { useEffect, useState } from 'react';
import { updateInspectionAPI, updateVerdictApi, verdictApi } from '../../../apiCalls/iqcAPIs';
import { showToastError, showToastInfo, showToastSuccess } from '../../../../../common/toasters/toasterMessages';

export const KeyDetails = (props) => {

  const { inspectionDetails, fetchInspectionDetailsByKey } = props.values;

  const [items, setItems] = useState([])
  const [verdictStatusList, setVerdictStatusList] = useState([])
  const [isChanging, setIsChanging] = useState(false);
  const [verdict, setVerdict] = useState("No Status");
  const [remarksChanged, setRemarksChanged] = useState(false);
  const [remarks, setRemarks] = useState(inspectionDetails?.remarks || '');

  const handleStatusChange = async (value) => {
    setIsChanging(true);
    setVerdict(value);
    let body = {
      verdict: value,
    };
    let response = await updateVerdictApi(inspectionDetails?.id, body);
    if (response.isError) {
      showToastError(response.displayableMessage);
    } else {
      showToastInfo(response.displayableMessage);
      fetchInspectionDetailsByKey();
    }
    setIsChanging(false);
  }

  const fetchVerdictStatuses = async () => {
    let response = await verdictApi();
    setVerdictStatusList(response?.data);
  }

  const handleRemarksChange = async (e) => {
    setRemarksChanged(true);
    const val = e.target.value;
    setRemarks(val);
  }

  const handleSaveRemarks = async () => {
    let assigneesList = [];
    inspectionDetails?.qualityInspectionAssignees?.map(inspection =>
      assigneesList.push(inspection?.assigneeId)
    );
    const body = {
      quantity: inspectionDetails?.quantity,
      samplingType: inspectionDetails?.samplingType,
      samplingNumber: inspectionDetails?.meta?.samplingDetails?.number,
      assignees: assigneesList,
      supplierId: inspectionDetails?.supplier?.id,
      linkedSheets: inspectionDetails?.meta?.linkedSheets,
      dueDateTime: inspectionDetails?.dueDateTime,
      deliveryStatus: inspectionDetails?.meta?.deliveryStatus,
      invoiceNumber: inspectionDetails?.meta?.invoiceNumber,
      grnNumber: inspectionDetails?.meta?.grnNumber,
      invoiceDate: inspectionDetails?.meta?.invoiceDate,
      deliveryDateTime: inspectionDetails?.meta?.deliveryDateTime,
      remarks: remarks,
    }

    const response = await updateInspectionAPI(inspectionDetails?.id, body);
    if (response.isError) {
      showToastError(response?.displayableMessage);
    } else {
      setRemarksChanged(false);
      showToastSuccess(response?.displayableMessage);
      fetchInspectionDetailsByKey();
    }
  }

  useEffect(() => {
    fetchVerdictStatuses();
    if (inspectionDetails) {
      setItems(keyDetailsItems(verdict, isChanging, handleStatusChange, inspectionDetails))
    }
    if (inspectionDetails?.verdict !== "") {
      setVerdict(inspectionDetails?.verdict);
    }
  }, [inspectionDetails])

  useEffect(() => {

    if (verdictStatusList.length > 0) {
      let verdictOptions = [];
      verdictStatusList?.forEach(verdict => {
        verdictOptions.push({
          value: verdict.title,
          label: verdict.title === "ACCEPTED" ?
            "Accepted" : verdict.title === "REJECTED" ?
              "Rejected" : verdict.title === "IN_REVIEW" ?
                "In Review" : verdict.title === "CONDITIONALLY_APPROVED" ?
                  "Conditionally Approved" : "",
          color: verdict.color
        })
      });
      setItems(keyDetailsItems(verdict, isChanging, handleStatusChange, inspectionDetails, verdictOptions, remarksChanged, handleRemarksChange, handleSaveRemarks, remarks))
    }
  }, [verdictStatusList, verdict, isChanging, remarksChanged, remarks])

  return (
    <Descriptions bordered items={items} />
  )
};